import React, { useState, useEffect } from "react";
import { Container, Card, Spinner, Badge } from "react-bootstrap";
import { FaBell, FaCalendarAlt, FaTag } from "react-icons/fa";
import Layout from "../hocs/Layout";
import { resourceService } from "../services/resourceService";
import { formatReleaseTitle, parseReleaseDescription } from "../utils/releaseNotesFormatter";

function Novedades() {
    const [releases, setReleases] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const data = await resourceService.getResources("release_notes");
                setReleases(data);
            } catch (error) {
                console.error("Error loading release notes:", error);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    return (
        <Layout>
            <Container className="py-4">
                <div className="mb-5 animate-in d-flex align-items-center gap-3">
                    <div className="p-3 bg-primary bg-opacity-10 rounded-circle">
                        <FaBell size={28} className="text-primary" />
                    </div>
                    <div>
                        <h2 className="display-6 fw-bold text-primary mb-1">Novedades</h2>
                        <p className="text-muted mb-0">Historial de versiones y cambios de la plataforma.</p>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : releases.length === 0 ? (
                    <div className="text-center py-5 bg-white rounded-4 shadow-sm">
                        <p className="text-muted mb-0">No hay novedades publicadas todavía.</p>
                    </div>
                ) : (
                    <div className="position-relative">
                        {/* Timeline line */}
                        <div
                            className="d-none d-md-block position-absolute bg-primary bg-opacity-25"
                            style={{ left: '24px', top: '12px', bottom: '12px', width: '2px' }}
                        />
                        <div className="d-flex flex-column gap-4">
                            {releases.map((release, idx) => {
                                const parsed = parseReleaseDescription(release.description);
                                const displayTitle = formatReleaseTitle(release);
                                return (
                                    <div key={release.id} className="d-flex gap-4 animate-in" style={{ animationDelay: `${idx * 0.05}s` }}>
                                        {/* Timeline dot */}
                                        <div className="d-none d-md-flex align-items-start pt-1 flex-shrink-0" style={{ zIndex: 1 }}>
                                            <div
                                                className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                                                style={{ width: '48px', height: '48px', fontSize: '0.7rem', flexShrink: 0 }}
                                            >
                                                {release.version || 'v?'}
                                            </div>
                                        </div>

                                        <Card className="flex-grow-1 border-0 shadow-sm">
                                            <Card.Body className="p-4">
                                                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                                                    <h4 className="fw-bold mb-0">{displayTitle}</h4>
                                                    {release.version && (
                                                        <Badge bg="primary" className="rounded-pill d-flex align-items-center gap-1">
                                                            <FaTag size={10} />
                                                            {release.version}
                                                        </Badge>
                                                    )}
                                                    {idx === 0 && (
                                                        <Badge bg="success" className="rounded-pill">Última versión</Badge>
                                                    )}
                                                </div>

                                                <div className="d-flex align-items-center gap-1 text-muted small mb-3">
                                                    <FaCalendarAlt size={12} />
                                                    <span>
                                                        {new Date(release.release_date || release.upload_date).toLocaleDateString('es-ES', {
                                                            year: 'numeric', month: 'long', day: 'numeric'
                                                        })}
                                                    </span>
                                                </div>

                                                {parsed.sections.map((section) => (
                                                    <div key={`${release.id}-${section.key}`} className="mb-2">
                                                        <p className="fw-semibold mb-1 text-dark" style={{ fontSize: '0.92rem' }}>
                                                            {section.title}
                                                        </p>
                                                        <ul className="mb-0" style={{ paddingLeft: '1.1rem' }}>
                                                            {section.items.map((item, pointIdx) => (
                                                                <li key={`${release.id}-${section.key}-${pointIdx}`} className="text-secondary mb-1" style={{ lineHeight: '1.6' }}>
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                                {parsed.notes.length > 0 && (
                                                    <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>
                                                        {parsed.notes.join(' ')}
                                                    </p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </Container>
        </Layout>
    );
}

export default Novedades;
